import React, {useState, useContext} from 'react';
import {ViewProvider} from './contexts/ViewContext';
import Main from './Main';
import CssBaseline from '@material-ui/core/CssBaseline';

function App() {
	return (
		<div>
			<CssBaseline />
			<ViewProvider>
				<Main />
			</ViewProvider>
		</div>
	);
}

export default App;
